import { FC, useState } from "react";
import { DefaultGrid } from "../../../components/grids/default/defaultGrid";
import { PluginWrapper } from "../../../components/plugins";
import useGridFilter from "../../../system/hooks/useGridFilter";
import { IDocumentTypes } from "../../../libs/coreapi-dto/dirs/documentTypes";

export const DocumentTypesDictionaryData: IDocumentTypes[] = [
    {
        idGlobal: '2',
        documentTypes: 'invoice',
        displayName: 'Приходная накладная' 
    },
    {
        idGlobal: '3',
        documentTypes: 'act_return_to_contractor',
        displayName: 'Акт возврата поставщику' 
    },
    {
        idGlobal: '6',
        documentTypes: 'act_disassembling',
        displayName: 'Акт разукомплектации' 
    },
    {
        idGlobal: '7',
        documentTypes: 'cheque',
        displayName: 'Кассовый чек' 
    },
    {
        idGlobal: '8',
        documentTypes: 'movement',
        displayName: 'Перемещение товара' 
    },
    {
        idGlobal: '12',
        documentTypes: 'act_return_to_buyer',
        displayName: 'Акт возврата от покупателя' 
    },
    {
        idGlobal: '13',
        documentTypes: 'act_revaluation',
        displayName: 'Акт переоценки' 
    },
    {
        idGlobal: '19',
        documentTypes: 'cash_session',
        displayName: 'Кассовая смена' 
    },
    {
        idGlobal: '22',
        documentTypes: 'bill',
        displayName: 'Счёт' 
    },
    {
        idGlobal: '23',
        documentTypes: 'inventory_ved',
        displayName: 'Инвентаризация' 
    },
    {
        idGlobal: '24',
        documentTypes: 'inventory_sved',
        displayName: 'Инвентаризация сводная' 
    },
    {
        idGlobal: '30',
        documentTypes: 'import_remains',
        displayName: 'Ввод остатков' 
    },
    {
        idGlobal: '35',
        documentTypes: 'request_for_movement',
        displayName: 'Заявка на перемещение' 
    },
    {
        idGlobal: '45',
        documentTypes: 'internet_order',
        displayName: 'Интернет заказ' 
    },
    {
        idGlobal: '59',
        documentTypes: 'eshop_order',
        displayName: 'Заказ интернет-магазина' 
    },
    {
        idGlobal: '66',
        documentTypes: 'act_disagregation',
        displayName: 'Акт разагрегации' 
    },
    {
        idGlobal: '222',
        documentTypes: 'invoice_out',
        displayName: 'Расходная накладная' 
    },
    {
        idGlobal: '250',
        documentTypes: 'act_deduction',
        displayName: 'Акт списания' 
    },
]

export const DocumentTypesGrid: FC<IGridProps> = (props) => {
    const [totalCount, setTotalCount] = useState(DocumentTypesDictionaryData.length);
    const [gridFilter, dispatchGridFilter] = useGridFilter();
    const [selectedItem, setSelectedItem] = useState<IGridRow>();
    const [selectedItems, setSelectedItems] = useState<IGridRow[]>(props?.data ?? []);

    return (
        <PluginWrapper>
            <DefaultGrid
                showQuantity
                gridId={props.gridId}
                data={DocumentTypesDictionaryData}
                separator
                singleDirectory
                totalCount={totalCount}
                filter={gridFilter}
                plugin={props.plugin}
                selectedItem={selectedItem}
                selectedItems={selectedItems}
                multipleSelect={props.multipleSelect}
                onDoubleClick={(row) => props.onDoubleClick?.(row)}
                onSelect={(row) => {
                    setSelectedItem(row)
                    props.onSelect?.(row)
                }}
                onMultipleSelect={(rows) => {
                    setSelectedItems(rows)
                    props?.onMultipleSelect?.(rows)
                }}
                onSort={(i) => dispatchGridFilter({ type: "sort", payload: i.propertyName })}
                onFilterDelete={(i) => dispatchGridFilter({ type: "deleteColumnFilter", payload: i.propertyName })}
                onPageNumberChange={(n) => dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: n } })}
                onNumberPerPageChange={(n) => dispatchGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } })}
                hiddenPagination={{ hiddenNumberPage: true, hiddenCountRow: false }}
            />
        </PluginWrapper>
    )
}